import { configure } from 'mobx';
import React, { ComponentType, Suspense } from 'react';
import { PageViewProps } from './components/page-view';
import { BaseProps, RightLayoutProps } from './components/page-view/types';
import './components/store';
import { RouteNoPermissionProps } from './routes/NoPermission';
import './style/lib.less';
import ebdcoms from './utils/ebdcoms';
import './utils/event-plugins/CompLoadPlugin';
import './utils/pageCache';
import PageLoadable from './utils/pageLoadable';
import './utils/shallowObservable';

/* mobx 配置 */
configure({ enforceActions: 'always' });

export * from './common';
export { PageProvider as GridPageProvider } from './common/PageContext';
export { default as HrmCombine } from './routes/dialogs/hrmCombine';
export { UniqueDialogs, UniqueSystemDialog } from './routes/dialogs/index';
export { default as PageDialog } from './routes/dialogs/page';
export { default as SystemDialog } from './routes/dialogs/system';
export { default as viewUtils } from './utils/view';

type LazyCom = () => Promise<{ default: ComponentType<any> }>;

export const lazy = (lazyCom: LazyCom) => React.lazy(() => ebdcoms.load().then(lazyCom));

const LazyCodePageView = React.lazy(
  () => import(
    /* webpackChunkName: "page_codepageview" */
    './pages/CodePageView'
  ),
);

const loaderPageView = () => import(
  /* webpackChunkName: "page_pageview" */
  './components/page-view'
);

const loaderMPageView = () => import(
  /* webpackChunkName: "page_pageview_m" */
  './components/page-view-m'
);

/** 事件动作中使用右侧推出 */
const LazyRightLayout = React.lazy(
  () => import(
    /* webpackChunkName: "page_rightlayout" */
    /* webpackMode: "eager" */
    './components/page-view/RightLayout'
  ),
);

const LazyRoutePageView = lazy(
  () => import(
    /* webpackChunkName: "page_routepage" */
    /* webpackMode: "eager" */
    './routes'
  ),
);

const LazyRouteNoPermission = React.lazy(
  () => import(
    /* webpackChunkName: "page_exception" */
    /* webpackMode: "eager" */
    './routes/NoPermission'
  ),
);

const LazyNoPermissionPage = React.lazy(
  () => import(
    /* webpackChunkName: "page_exception" */
    './components/permission/Content'
  ),
);

const LazyRoutePageError = React.lazy(
  () => import(
    /* webpackChunkName: "page_exception" */
    /* webpackMode: "eager" */
    './routes/PageError'
  ),
);

export const CodePageView: React.FC<BaseProps> = (props: BaseProps) => (
  <Suspense weId={`${props.weId || ''}_7s6w1t`} fallback={<div />}>
    <LazyCodePageView weId={`${props.weId || ''}_ho9hpl`} {...props} />
  </Suspense>
);

export const PageView = PageLoadable({
  name: 'PageView',
  loader: loaderPageView,
  lazyLoader: false,
}) as React.FC<PageViewProps>;

export const MPageView = PageLoadable({
  name: 'MPageView',
  loader: loaderMPageView,
  lazyLoader: false,
}) as React.FC<BaseProps>;

/**
 * ebdfpage项目中有使用
 */

export const RightLayout: React.FC<RightLayoutProps> = (props: RightLayoutProps) => (
  <Suspense weId={`${props.weId || ''}_guh2ak`} fallback={<div />}>
    <LazyRightLayout weId={`${props.weId || ''}_olb2cu`} {...props} />
  </Suspense>
);

export const RoutePageView: React.FC<any> = (props: BaseProps) => (
  <Suspense weId="dg4e48" fallback={<div />}>
    <LazyRoutePageView weId="_vctfcz" {...props} />
  </Suspense>
);

export const RouteNoPermission: React.FC<RouteNoPermissionProps> = (
  props: RouteNoPermissionProps,
) => (
  <Suspense weId={`${props.weId || ''}_yxygv1`} fallback={<div />}>
    <LazyRouteNoPermission weId={`${props.weId || ''}_7ut6cy`} {...props} />
  </Suspense>
);

export const NoPermissionPage: React.FC<{ code: string }> = (props) => (
  <Suspense weId="v1yxyg" fallback={<div />}>
    <LazyNoPermissionPage weId="6cy7ut" {...props} />
  </Suspense>
);

export const RoutePageError: React.FC<any> = (props) => (
  <Suspense weId={`${props.weId || ''}_phur2m`} fallback={<div />}>
    <LazyRoutePageError weId={`${props.weId || ''}_lpc0vf`} {...props} />
  </Suspense>
);

export const RouteMain: React.FC<any> = (props) => (
  <Suspense weId={`${props.weId || ''}_phur2m`} fallback={<div />}>
    <RoutePageView weId={`${props.weId || ''}_lpc0vf`} isRouteMain {...props} />
  </Suspense>
);

export const MRouteMain: React.FC<any> = (props) => (
  <Suspense weId={`${props.weId || ''}_phur2m`} fallback={<div />}>
    <RoutePageView weId={`${props.weId || ''}_lpc0vf`} isRouteMain clientType="MOBILE" {...props} />
  </Suspense>
);

export default {};
